var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-column": "", "md-align": "start" } },
    [
      _vm.loadingComponent
        ? _c("md-progress", {
            staticClass: "md-accent",
            attrs: { "md-indeterminate": "" }
          })
        : _c(
            "md-theme",
            { attrs: { "md-name": "blue" } },
            [
              _c("breadcrumbs", {
                attrs: {
                  id: "scrollToError",
                  section: "Domain Lists",
                  nav: _vm.nav
                }
              }),
              _c(
                "md-layout",
                { staticClass: "form-wrapper", attrs: { "md-gutter": 16 } },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "100", "md-flex-small": "100" } },
                    [
                      _c(
                        "md-whiteframe",
                        {
                          staticClass: "form-wrapper-frame",
                          attrs: { "md-elevation": "3" }
                        },
                        [
                          _c("metadata-form", {
                            attrs: {
                              title: "Domain List",
                              entity: _vm.domainList,
                              "form-submitted": _vm.formSubmitted,
                              validations: _vm.$v.domainList
                            }
                          }),
                          _c("status-radio", {
                            model: {
                              value: _vm.domainList.status,
                              callback: function($$v) {
                                _vm.$set(_vm.domainList, "status", $$v)
                              },
                              expression: "domainList.status"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "md-headline",
                              attrs: { id: "targets" }
                            },
                            [_vm._v("Targets")]
                          ),
                          _c("md-chips", {
                            staticClass: "domainContainer",
                            class: {
                              "md-input-invalid":
                                _vm.formSubmitted &&
                                _vm.$v.domainList.domains.$invalid
                            },
                            attrs: {
                              id: "domain-input",
                              "md-input-placeholder":
                                "Type to add a new domain..."
                            },
                            on: { change: _vm.onDomainsChanged },
                            model: {
                              value: _vm.domainList.domains,
                              callback: function($$v) {
                                _vm.$set(_vm.domainList, "domains", $$v)
                              },
                              expression: "domainList.domains"
                            }
                          }),
                          _c(
                            "md-layout",
                            {
                              staticClass: "bulkUpload",
                              attrs: { "md-flex": "40 " }
                            },
                            [
                              _c(
                                "md-input-container",
                                [
                                  _c("label", [_vm._v(_vm._s(_vm.bulkStatus))]),
                                  _c("md-file", {
                                    staticClass: "search-btn",
                                    attrs: {
                                      accept: ".csv",
                                      disabled: _vm.loadingComponent
                                    },
                                    on: { selected: _vm.onFileSelected },
                                    model: {
                                      value: _vm.fileName,
                                      callback: function($$v) {
                                        _vm.fileName = $$v
                                      },
                                      expression: "fileName"
                                    }
                                  }),
                                  _c(
                                    "md-button",
                                    {
                                      staticClass: "search-btn md-icon-button",
                                      attrs: {
                                        disabled:
                                          _vm.loadingComponent ||
                                          this.file === null
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.takeDomains()
                                        }
                                      }
                                    },
                                    [
                                      _c("md-icon", {
                                        staticClass: "md-icon",
                                        attrs: { "md-iconset": "fa fa-upload" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "btn-del-div" },
                            [
                              _c(
                                "md-button",
                                {
                                  attrs: { id: "btn-delete" },
                                  on: { click: _vm.deleteDomainList }
                                },
                                [_vm._v("Delete all domains")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "md-layout",
                    {
                      staticClass: "errorMsg",
                      attrs: { "md-align": "center" }
                    },
                    [
                      _vm.formSubmitted &&
                      _vm.hasDomains &&
                      _vm.$v.domainList.domains.$each.$invalid
                        ? _c("span", [
                            _vm._v("Some of the domains has a wrong format.")
                          ])
                        : _vm._e(),
                      _vm.formSubmitted && !_vm.$v.domainList.domains.required
                        ? _c("span", [
                            _vm._v("You must enter at least one domain.")
                          ])
                        : _vm._e(),
                      _c("span", [_vm._v(_vm._s(_vm.errorStatus))]),
                      _c("stitch-loader", {
                        attrs: { loading: _vm.creatingOrUpdating, size: 40 }
                      }),
                      _c(
                        "md-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.creatingOrUpdating,
                              expression: "!creatingOrUpdating"
                            }
                          ],
                          staticClass: "md-raised md-primary",
                          attrs: {
                            id: "submit-btn",
                            disabled: _vm.$v.$pending
                          },
                          on: { click: _vm.onFormSubmit }
                        },
                        [_vm._v(_vm._s(_vm.editMode ? "Update" : "Create"))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfcdb782", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfcdb782","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/domain/DomainForm.vue
// module id = 835
// module chunks = 0